export const PREROLL = 'PREROLL';
export const MIDROLL = 'MIDROLL';
export const POSROLL = 'POSROLL';
export const OVERLAY = 'OVERLAY';

export const SSP_POSITIONS = ['', PREROLL, MIDROLL, POSROLL];
